export default __webpack_public_path__ + "styled.d.ts";